module.exports = __webpack_public_path__ + "static/media/Profile.829d8e12.jpg";